var _path, _path2, _g, _path3, _path4, _ellipse, _g2, _ellipse2, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBravotours = function SvgBravotours(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6F9FF",
    d: "M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bravotours_svg__a",
    width: 7,
    height: 5,
    x: 16,
    y: 16,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.84 16.386a6 6 0 0 0-.365.167c-.901.493-3.12 3.09-3.123 3.514v.028c.042.225 3.77.494 4.78.183.069-.022.305-.119.374-.147a2.05 2.05 0 0 0 1.263-1.88c0-.272-.056-.547-.174-.813a2.11 2.11 0 0 0-1.924-1.225c-.28 0-.562.054-.835.17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bravotours_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bravotours_svg__b)",
    d: "M22.775 16.217h-6.423v4.376h6.423z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bravotours_svg__c",
    width: 7,
    height: 9,
    x: 15,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.702 13.255a2.4 2.4 0 0 0-.52.785c-.033.08-.148.366-.17.449-.103.35-.149.955-.149 1.645 0 1.51.207 3.42.444 3.895.026.051.05.08.076.096.47.362 3.62-2.731 4.3-3.79.088-.137.164-.294.23-.503a3 3 0 0 0 .135-.862c0-.997-.553-1.898-1.565-2.299a2.6 2.6 0 0 0-.812-.173h-.132c-.69 0-1.354.276-1.834.76"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bravotours_svg__c)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bravotours_svg__d)",
    d: "m18.005 10.007-6.177 7.179 7.077 5.79 6.176-7.178z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bravotours_svg__f",
    width: 4,
    height: 6,
    x: 16,
    y: 13,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.39,
    cy: 2.473,
    fill: "url(#bravotours_svg__e)",
    rx: 1.39,
    ry: 2.473,
    transform: "matrix(.96135 .28038 -.28897 .95581 17.25 13.203)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bravotours_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F84CB",
    d: "M19.011 13.84c-.867.603-1.693 3.006-1.997 4.132l.48.623 2.334-2.143z",
    opacity: 0.6
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "bravotours_svg__h",
    width: 5,
    height: 3,
    x: 18,
    y: 17,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.114,
    cy: 1.946,
    fill: "url(#bravotours_svg__g)",
    rx: 1.114,
    ry: 1.946,
    transform: "matrix(.4474 .8622 -.91732 .45515 21.527 16.55)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bravotours_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#287ABF",
    d: "M22.108 17.888c-.83-.162-2.7.677-3.53 1.117l-.104.609 2.544.152z",
    opacity: 0.9
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M5.132 27.41c.809 0 1.465-.59 1.465-1.403a1.25 1.25 0 0 0-.683-1.143c.305-.223.494-.576.494-1.003 0-.783-.64-1.359-1.429-1.359h-1.94v4.908zm-1.29-2.862v-1.293h1.137c.355 0 .627.28.627.646a.626.626 0 0 1-.627.647zm1.29.733c.378 0 .663.3.663.686v.004c0 .386-.285.686-.663.686h-1.29V25.28z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M8.936 24.661v-.82c-.438 0-.866.177-1.075.653v-.59h-.753v3.506h.753v-1.766c0-.786.58-1.02 1.075-.983"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M12.783 27.41h-.753v-.507c-.265.374-.677.597-1.22.597-.949 0-1.738-.806-1.738-1.846s.789-1.846 1.737-1.846c.544 0 .956.223 1.22.59V23.9h.754zm-.753-1.753c0-.653-.474-1.123-1.104-1.123s-1.105.47-1.105 1.123.474 1.123 1.104 1.123 1.105-.47 1.105-1.123",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "m15.351 27.41 1.36-3.505h-.823l-.972 2.665-.974-2.665h-.826l1.363 3.505z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M16.712 25.657c0-1.046.822-1.846 1.843-1.846 1.022 0 1.844.8 1.844 1.846a1.82 1.82 0 0 1-1.844 1.846 1.826 1.826 0 0 1-1.843-1.846m2.931 0c0-.64-.474-1.11-1.088-1.11-.613 0-1.087.47-1.087 1.11s.474 1.11 1.087 1.11c.614 0 1.088-.47 1.088-1.11",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M23.616 23.275h1.373v-.773h-3.558v.773h1.383v4.135h.802z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    fillRule: "evenodd",
    d: "M24.306 25.657c0-1.046.822-1.846 1.844-1.846 1.021 0 1.844.8 1.844 1.846a1.82 1.82 0 0 1-1.844 1.846 1.826 1.826 0 0 1-1.844-1.846m2.932 0c0-.64-.475-1.11-1.088-1.11s-1.088.47-1.088 1.11.474 1.11 1.088 1.11c.613 0 1.088-.47 1.088-1.11",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E2336",
    d: "M31.615 27.41v-3.509h-.753v1.88c0 .716-.411 1.01-.886 1.01-.474 0-.782-.28-.782-.814v-2.076h-.753v2.153c0 .913.557 1.446 1.34 1.446.474 0 .849-.173 1.08-.54v.45zM34.042 23.841v.82c-.494-.037-1.075.197-1.075.983v1.766h-.752v-3.505h.752v.59c.21-.477.637-.654 1.075-.654M35.515 27.503c.753 0 1.36-.376 1.36-1.08h.003c0-.76-.648-.941-1.182-1.09-.375-.105-.695-.195-.695-.459 0-.253.226-.373.51-.373.286 0 .531.127.657.4l.634-.357c-.242-.463-.717-.73-1.29-.73-.71 0-1.277.414-1.277 1.074 0 .737.646.92 1.18 1.073.376.107.697.199.697.456 0 .28-.259.393-.594.393-.384 0-.663-.19-.776-.506l-.65.38c.223.503.727.82 1.423.82"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bravotours_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 2.47322 -1.38974 0 1.39 2.473)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bravotours_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 1.94567 -1.1137 0 1.114 1.946)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bravotours_svg__b",
    x1: 16.619,
    x2: 23.04,
    y1: 18.561,
    y2: 18.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EB1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2A97D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2577BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bravotours_svg__d",
    x1: 15.252,
    x2: 20.229,
    y1: 19.754,
    y2: 13.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246BB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#41C7F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41C7F2"
  })))));
};
export default SvgBravotours;